import  { useEffect, useState } from "react";
import Pagination from "react-bootstrap/Pagination";
import Table from "react-bootstrap/Table";
import PropTypes from "prop-types";
import { myId } from "../Pages/ResultTable";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { IoClose } from "react-icons/io5";

const initDataTable = {
  actualPage: 1,
  totalPages: 1,
  data: [],
  rowsPerPage: 10,
};

const TableCustomersAOM = ({ dataCustomersAOM, setShowTCAOM }) => {
  const [dataTable, setDataTable] = useState(initDataTable);
  const [dataSearch, setDataSearch] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [doSearch, setDoSearch] = useState(false);

  //console.log("dataCustomersAOM(TableCustomersAOM):...", dataCustomersAOM);
  useEffect(() => {
    const totalPages = Math.ceil(
      dataCustomersAOM?.length / dataTable.rowsPerPage
    );
    setDataTable({
      ...dataTable,
      totalPages,
      data: dataCustomersAOM.slice(0, dataTable.rowsPerPage),
    });
    initDataSearch();
  }, []);

  const initDataSearch = () => {
    let tempDataSearch = [];
    dataCustomersAOM.map((customer) => {

        if (!tempDataSearch.includes(customer.customer_no)) {
            tempDataSearch.push({
              value: customer.customer_no,
              label: customer.customer_no,
            });
          }

      if (!tempDataSearch.includes(customer.email_address)) {
        tempDataSearch.push({
          value: customer.email_address,
          label: customer.email_address,
        });
      }
      if (!tempDataSearch.includes(customer.first_name)) {
        tempDataSearch.push({
          value: customer.first_name,
          label: customer.first_name,
        });
      }
      if (!tempDataSearch.includes(customer.last_name)) {
        tempDataSearch.push({
          value: customer.last_name,
          label: customer.last_name,
        });
      }
    });
    setDataSearch(tempDataSearch);
  };

  useEffect(() => {
    console.log(
      "dataTable(Cambio en el Contenido a Renderizar):...",
      dataTable
    );
  }, [dataTable]);

  const handleChangeRowsPerPage = (e) => {
    console.log("e.target.value:...", e.target.value);
    const rowsPerPage = Number(e.target.value);
    const totalPages = Math.ceil(dataCustomersAOM?.length / rowsPerPage);
    const initReg = dataTable.actualPage * rowsPerPage - rowsPerPage;
    const endReg = dataTable.actualPage * rowsPerPage;
    setDataTable({
      ...dataTable,
      totalPages,
      rowsPerPage,
      data: dataCustomersAOM.slice(initReg, endReg),
    });
  };

  const handleChangeSearch = (e) => {
    console.log("handleSearchValue:...", e.target.value);
    const textSearch = e.target.value;

    //console.log("tempData(handleSearch):...", tempData);

    setSearchValue(e.target.value);
  };

  const handleDoSearch = (e) => {
    const textSearch = e.value;
    const tempData = dataCustomersAOM.filter((customer) => {
      return (
        customer.email_address === textSearch ||
        customer.first_name === textSearch ||
        customer.last_name === textSearch ||
        String(customer.customer_no) === textSearch
      );
    });
    setDataTable({
      ...dataTable,
      actualPage: 1,
      totalPages: Math.ceil(tempData.length / dataTable.rowsPerPage),
      data: tempData.slice(0, dataTable.rowsPerPage),
    });
  };

  const handleClose = () => {
    console.log("handleClose...");
    setShowTCAOM(false);
  }

  return (
    <div className="">
      <div className="fs-3 m-2 d-flex  border bg-light rounded w-100">
        <div className="text-end w-50 ">
        Data Customers CRM
        </div>
        <div className="text-end w-50  pe-3 ">
          <span onClick={handleClose} className="btn btn-light fs-4">
        <IoClose/>
        </span>
        </div>
      </div>
      <Select 
      className="m-2 p-2 w-50 d-none ms-auto me-auto "
      options={dataSearch} 
      onChange={handleDoSearch}
      placeholder="Search..."
      />
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Customer Num</th>
            <th>Email</th>
            <th>Name</th>
            <th>Last Name</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.data.map((customer, index) => (
            <tr key={myId()}>
                <td>{customer.customer_no}</td>
              <td>{customer.email_address}</td>
              <td>{customer.first_name}</td>
              <td>{customer.last_name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination className=" d-flex justify-content-center align-items-center w-100">
        <Pagination.First
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: 1,
              data: dataCustomersAOM.slice(0, dataTable.rowsPerPage),
            });
          }}
        />
        <Pagination.Prev
          onClick={() => {
            if (dataTable.actualPage === 1) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage - 1,
              data: dataCustomersAOM.slice(
                (dataTable.actualPage - 2) * dataTable.rowsPerPage,
                (dataTable.actualPage - 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Item active>{dataTable.actualPage}</Pagination.Item>
        <Pagination.Ellipsis />
        <Pagination.Item>{dataTable.totalPages}</Pagination.Item>
        <Pagination.Next
          onClick={() => {
            if (dataTable.actualPage === dataTable.totalPages) return;
            setDataTable({
              ...dataTable,
              actualPage: dataTable.actualPage + 1,
              data: dataCustomersAOM.slice(
                dataTable.actualPage * dataTable.rowsPerPage,
                (dataTable.actualPage + 1) * dataTable.rowsPerPage
              ),
            });
          }}
        />
        <Pagination.Last
          onClick={() => {
            setDataTable({
              ...dataTable,
              actualPage: dataTable.totalPages,
              data: dataCustomersAOM.slice(
                (dataTable.totalPages - 1) * dataTable.rowsPerPage,
                dataTable.totalPages * dataTable.rowsPerPage
              ),
            });
          }}
        />

        <Form.Select
          style={{ width: "60px" }}
          className="m-1 p-1"
          name="rowsPerPage"
          onChange={handleChangeRowsPerPage}
          id=""
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
        </Form.Select>
      </Pagination>
    </div>
  );
};

TableCustomersAOM.propTypes = {
  dataCustomersAOM: PropTypes.array.isRequired,
};

export default TableCustomersAOM;

/**
 * 
 * address_1:"Union"
address_2:"32"
address_3:"Barrio La Fama"
birth_date:"1969-12-31T00:00:00.000Z"
customer_id:97161
customer_no:999000097161
email_address:"jalberto.goku@gmail.com"
first_name:"Alberto"
gender:"M"
last_name:"Gonzalez"
marital_status:"S"
post_code:"14269"
system_modify_date:"2024-02-25T21:09:00.000Z"
telephone_no:"525591990395"
 * 

{
                Array.from({length: dataTable.totalPages}, (_, index) => (
                    <Pagination.Item 
                    key={index}
                    active={index+1 === dataTable.actualPage}
                    onClick={() => {
                        setDataTable({
                            ...dataTable,
                            actualPage: index+1,
                            data: dataCustomersAOM.slice(index*dataTable.rowsPerPage, (index+1)*dataTable.rowsPerPage)
                        });
                    }}
                    >
                        {index+1}
                    </Pagination.Item>
                ))
            }



 * 
 */
